module.exports = __webpack_public_path__ + "img/default-briefs.4db21bb8.png";